import { render } from "./Typescale.vue?vue&type=template&id=6d8e2622&ts=true&lang=html"
import script from "./Typescale.vue?vue&type=script&lang=ts"
export * from "./Typescale.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__